var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThinkingOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M358.172,132.696c-22.974-40.344-64.94-66.181-111.308-68.528v0c-75.015-3.791-138.9,53.948-142.691,128.963    C104.058,195.419,104,197.709,104,200c0.068,48.653,26.063,93.58,68.208,117.888c7.328,4.271,11.823,12.126,11.792,20.608V432    c0,4.418,3.582,8,8,8h8c0,22.091,17.909,40,40,40c22.091,0,40-17.909,40-40h8c4.418,0,8-3.582,8-8v-93.472    c-0.158-8.317,4.149-16.082,11.288-20.352C372.558,281.008,395.339,197.966,358.172,132.696z M240,464c-13.255,0-24-10.745-24-24    h48C264,453.255,253.255,464,240,464z M280,424h-80v-15.72c15.352-0.096,51.528,0,80,0.128V424z M280,392.408    c-45.6-0.208-68.336-0.288-80,0V376h80V392.408z M280,360h-80v-16.216L280,344V360z M299.376,304.272L299.376,304.272    c-8.933,5.18-15.415,13.728-17.992,23.728l-82.864-0.2c-2.75-10.033-9.336-18.582-18.336-23.8    C143,282.558,120.063,242.923,120,200c-0.001-66.274,53.724-120.001,119.998-120.002c2.026,0,4.051,0.051,6.074,0.154    c66.189,3.36,117.122,59.74,113.762,125.929C357.758,246.984,334.964,284.003,299.376,304.272z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.532,113.125c-0.03-0.018-0.061-0.035-0.092-0.053l-27.72-16c-3.841-2.184-8.725-0.841-10.909,3    c-2.163,3.805-0.867,8.642,2.909,10.856l27.72,16c3.812,2.234,8.713,0.956,10.947-2.856    C110.622,120.261,109.343,115.359,105.532,113.125z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.442,276.02c-2.183-3.841-7.067-5.185-10.908-3.002c-0.031,0.018-0.062,0.036-0.093,0.054l-27.72,16    c-3.841,2.183-5.185,7.067-3.002,10.908c2.183,3.841,7.067,5.185,10.908,3.002c0.031-0.018,0.062-0.036,0.093-0.054l27.72-16    C109.281,284.745,110.625,279.861,108.442,276.02z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M410.373,289.126c-0.031-0.018-0.062-0.036-0.093-0.054l-27.72-16c-3.811-2.235-8.713-0.957-10.948,2.854    s-0.957,8.713,2.854,10.948c0.031,0.018,0.062,0.036,0.093,0.054l27.72,16c3.811,2.235,8.713,0.957,10.948-2.854    S414.185,291.361,410.373,289.126z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M413.288,100.019c-2.184-3.841-7.068-5.184-10.909-3c-0.031,0.017-0.061,0.035-0.092,0.053l-27.72,16    c-3.826,2.209-5.137,7.102-2.928,10.928c1.429,2.475,4.07,4,6.928,4c1.405,0.003,2.785-0.367,4-1.072l27.72-16    C414.129,108.744,415.472,103.86,413.288,100.019z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M339.926,26.812c-3.805-2.163-8.641-0.867-10.854,2.908l-16,27.72c-2.209,3.826-0.898,8.719,2.928,10.928    c3.826,2.209,8.719,0.898,10.928-2.928l16-27.72C345.111,33.879,343.768,28.995,339.926,26.812z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240,0c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8s8-3.582,8-8V8C248,3.582,244.418,0,240,0z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.981,57.532c-0.017-0.031-0.035-0.061-0.053-0.092l-16-27.72c-2.234-3.812-7.136-5.09-10.947-2.856    c-3.776,2.214-5.072,7.051-2.909,10.856l16,27.72c2.184,3.841,7.068,5.184,10.909,3S169.165,61.372,166.981,57.532z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80,192H48c-4.418,0-8,3.582-8,8s3.582,8,8,8h32c4.418,0,8-3.582,8-8S84.418,192,80,192z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432,192h-32c-4.418,0-8,3.582-8,8s3.582,8,8,8h32c4.418,0,8-3.582,8-8S436.418,192,432,192z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M312.168,167.832c-3.126-3.126-8.194-3.126-11.32,0L216,252.688l-39.6-39.6c-3.178-3.069-8.243-2.981-11.312,0.197    c-2.994,3.1-2.994,8.015,0,11.115l45.256,45.256c3.124,3.123,8.188,3.123,11.312,0l90.512-90.504    C315.294,176.026,315.294,170.958,312.168,167.832z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkingOrange);
export default __webpack_public_path__ + "static/media/thinking-orange.c45386a054a6532bf936b7c3916829d2.svg";
export { ForwardRef as ReactComponent };